import React, {useEffect, useState} from "react";
import InfiniteScroll from "react-infinite-scroller";
import {useDispatch, useSelector} from "react-redux";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Breadcrumbs from "../../../components/breadcrumbs";
import Button from "../../../components/button";
import Input from "../../../components/input";
import ItemList1 from "../../../components/item-list-1";
import Search from "../../../components/search";
import SelectInput from "../../../components/select";
import TextArea from "../../../components/text-area";
import {
    clear_custody,
    CREATE_CUSTODY, 
    createCustody,
    getAllCustody,
    get_report,
    GET_REPORT,
    getItemCustody,
    updateCustody,
    UPDATE_CUSTODY
} from '../../../redux/custody';
import Select from "react-select";
import LoadingSpinner from "../../../components/loading-spinner";
import {getAllCustodian} from "../../../redux/custodian";
import {getAllTypeCustody} from "../../../redux/type_custody";
import {get_status} from "../../../config";
import Card from "../../../components/card";
import Modal from "../../../components/modal";
import CheckBox from "../../../components/check-box";

const CustodesAdmin = (props) => {
    const dispatch = useDispatch();

    /* Usando el gancho useSelector para obtener el estado del módulo de custodys. */
    const _get_all_custody = useSelector((state) => state.custody_module._get_all_custody);
    
    const _get_all_custodian = useSelector((state) => state.custodian_module._get_all_custodian);
    const _get_all_type_custody = useSelector((state) => state.type_custody_module._get_all_type_custody);

    const _create_custody = useSelector((state) => state.custody_module._create_custody);
    const _update_custody = useSelector((state) => state.custody_module._update_custody);

    const _get_report = useSelector((store) => store.custody_module._get_report);

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    useEffect(() => {
        dispatch(getAllCustody(token, 1));
        dispatch(getAllCustodian(token));
        dispatch(getAllTypeCustody(token));
        // eslint-disable-next-line
    }, [token, dispatch]);


    const [showDetail, setShowDetail] = useState(false);
    const [showSibarLeft, setShowSibarLeft] = useState(false);
    const [showSibarRight, setShowSibarRight] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [custodian, setCustodian] = useState([]);
    const [typeCustody, setTypeCustody] = useState([]);
    const [modalDecline, setModalDecline] = useState(false);
    const [modalApproval, setModalApproval] = useState(false);
    const [modalEnd, setModalEnd] = useState(false);
    const [comment, setComment] = useState("");
    const [observation, setObservation] = useState("");

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (_get_all_custodian && _get_all_custodian.data && _get_all_custodian.data.datos) {
            // eslint-disable-next-line
            let array = _get_all_custodian.data.datos.map(element => {
                if (element.activo === true) {
                    return {
                        value: element.id,
                        label: element.nombre
                    }
                }
            })
            setCustodian(array);
        }
    }, [_get_all_custodian]);

    useEffect(() => {
        if (_get_all_type_custody && _get_all_type_custody.data && _get_all_type_custody.data.datos) {
            // eslint-disable-next-line
            let array = _get_all_type_custody.data.datos.map(element => {
                if (element.activo === true) {
                    return {
                        value: element.id,
                        label: element.descripcion
                    }
                }
            })
            setTypeCustody(array);
        }
    }, [_get_all_type_custody]);

    /* Creating an array of objects. */
    const filter_options = [
        {name: 'Rango de fechas', id: 1},
        {name: 'Tipo de custodia', id: 2},
        {name: 'Custodiador', id: 3},
    ];

    const [range_date, setRangeDate] = useState({
        visible: false,
        date_start: '',
        date_end: ''
    })

    const [other_filter, setOtherFilter] = useState({
        visible_type_custody: false,
        id_type_custody: 0,
        visible_custodian: false,
        id_custodian: 0,
    });

    const [datas, setDatas] = useState([]);
    const [count, setCount] = useState(0);
    const [HasMore, setHasMore] = useState(true);
    const [n_page, setNPage] = useState(0);

    const [page, setPage] = useState(1);

    function more_data() {
        let count = page + 1;
        setPage(count)
        dispatch(getAllCustody(token, count));
    }

    function less_data() {
        let count = page - 1;
        setPage(count)
        dispatch(getAllCustody(token, count));
    }

    const userEstablishmentsList = useSelector(
        (state) => state.users_module._session_data.data
    );

    const [establishment_select, setEstablishmentSelect] = useState([]);
    const [establishment, setEstablishment] = useState([]);

    // eslint-disable-next-line
    const initForm = {
        id: 0,
        id_tipo_custodia: 0,
        tipo_custodia: "",
        detalle: "",
        fecha_custodia: "",
        establecimientos: []
    };
    
    // eslint-disable-next-line
    const [form, setForm] = useState(initForm);

    const [permisos, setPermisos] = useState([]);

    useEffect(() => {
        let array = []
        if (userEstablishmentsList) {
            if (userEstablishmentsList.establecimientos) {
                array = userEstablishmentsList.establecimientos.map(element => {
                    return {
                        value: element.id,
                        label: element.nombre + ' (' + element.codigo + ')',
                    }
                })
            }
        }
        setEstablishment(array)
    }, [userEstablishmentsList])

    const handleChangeEstablishment = (e) => {
        setEstablishmentSelect(e);
    }
    useEffect(() => {
        if (_create_custody.status === 201) {
            toast.success("Custodio creado correctamente", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setForm(initForm);
            setShowOverlay(false);
            dispatch(clear_custody(CREATE_CUSTODY));
            dispatch(getAllCustody(token, 1));
            setShowSibarRight(false);
            setIsLoading(false);
        } else if (_create_custody.status !== 0) {
            toast.error(_create_custody.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setForm(initForm);
            setShowOverlay(false);
            setShowSibarRight(false);
            dispatch(clear_custody(CREATE_CUSTODY));
            setIsLoading(false);
        }
    }, [_create_custody, dispatch, initForm, token])

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
        if (_get_all_custody && _get_all_custody.data && _get_all_custody.data.datos) {
            setDatas(_get_all_custody.data.datos);
            setNPage(_get_all_custody.data.n_page);
        }

    }, [_get_all_custody, count, props]);

    const loadFunc = () => {
        if (_get_all_custody.data.datos) {
            if (_get_all_custody.data.datos.length > count) {
                const ordenado = _get_all_custody.data.datos.sort((a, b) => {
                    return new Date(b.fecha_custodia + ' 00:00:00') - new Date(a.fecha_custodia + ' 00:00:00');
                });
                setDatas([...datas, ...ordenado.slice(count, count + 10)]);
                setCount(count + 10);
            }
            setHasMore(false);
        }
    };

    const filterToday = (e) => {
        setTypeCustodySelectFilter([]);
        if (e.target.value === "0") {
            setDatas(_get_all_custody.data.datos);
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: false
            });
            setOtherFilter({
                visible_type_custody: false,
                id_type_custody: 0,
                visible_custodian: false,
                id_custodian: 0,
            });
        }
        if (e.target.value === '1') {
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: true
            });
        } else {
            setRangeDate({
                date_end: '',
                date_start: '',
                visible: false
            });
        }
        if (e.target.value === '2' || e.target.value === '3') {
            if (e.target.value === '2') {
                setOtherFilter({
                    visible_type_custody: true,
                    id_type_custody: 0,
                    visible_custodian: false,
                    id_custodian: 0,
                });
            }
            if (e.target.value === '3') {
                setOtherFilter({
                    visible_type_custody: false,
                    id_type_custody: 0,
                    visible_custodian: true,
                    id_custodian: 0,
                });
            }
        } else {
            setOtherFilter({
                visible_type_custody: false,
                id_type_custody: 0,
                visible_custodian: false,
                id_custodian: 0,
            });
        }
    }

    const handleChange = (e) => {
        if (e.target.name === "id_tipo_custodia" || e.target.name === "id_custodiador") {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    }

    const [type_custody_select, setTypeCustodySelect] = useState([]);
    const [date_custody, setDateCustody] = useState("");
    // const [id_custodian, setIdCustodian] = useState(0);

    const handleChangeTypeCustody = (e) => {
        setForm({
            ...form,
            // eslint-disable-next-line
            ['id_tipo_custodia']: parseInt(e.value),
            // eslint-disable-next-line
            ['tipo_custodia']: parseInt(e.label),
        });
        setTypeCustodySelect(e);
    }

    const [custodian_select, setCustodianSelect] = useState([]);

    const handleChangeCustodian = (e) => {
        // setIdCustodian(parseInt(e.value));
        setCustodianSelect(e);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        let array = establishment_select.map((item) => {
            return {
                id: item.value,
                nombre: item.label,
            };
        });
        form.establecimientos = array;
        // form.id_establecimiento = establishment_select.value;

        if (form.establecimientos.length === 0) {
            toast.error("Debe seleccionar al menos un establecimiento");
            setIsLoading(false);
            return;
        }

        if (form.id_tipo_custodia === 0) {
            toast.error("Debe seleccionar el tipo de la custodia");
            setIsLoading(false);
            return;
        }
        if (form.fecha_custodia === "") {
            toast.error("Debe seleccionar la fecha de la custodia");
            setIsLoading(false);
            return;
        }
        if (form.detalle === "") {
            toast.error("Debe ingresar el detalle");
            setIsLoading(false);
            return;
        }
        dispatch(createCustody(token, form));
    }

    const handleSearch = (e) => {
        setIsLoading(true);
        if (e.target.value === "") {
            setDatas(_get_all_custody.data.datos);
            setIsLoading(false);
            return;
        }
        setDatas([]);
        let nombre = e.target.value;
        nombre = nombre.trim();
        let re = new RegExp(nombre, "i");
        // eslint-disable-next-line
        let filtro = _get_all_custody.data.datos.filter(element => {
            if (element.establecimientos.match(re) != null || element.secuencial.match(re) != null) {
                return element;
            }
        })
        setDatas(filtro);
        setIsLoading(false);
    }

    const handleFilterRangeDate = (e) => {
        if (e.target.name === 'date_start') {
            range_date.date_start = e.target.value
        }
        if (e.target.name === 'date_end') {
            range_date.date_end = e.target.value
        }

        if (range_date.date_start !== '' && range_date.date_end !== '') {
            let date_start = new Date(range_date.date_start + ' 00:00:00');
            let date_end = new Date(range_date.date_end + ' 23:59:59');
            // eslint-disable-next-line
            let final = _get_all_custody.data.datos.filter(x => {
                    if (x.fecha_custodia) {
                        let fecha = new Date(x.fecha_custodia);
                        if (fecha.getTime() >= date_start.getTime() && fecha.getTime() <= date_end.getTime()) {
                            return x;
                        }
                    }
                }
            )
            setDatas(final);
        }
    }

    useEffect(() => {
        if (_get_report.status === 200) {
            toast.success(_get_report.data.mensaje);
            dispatch(clear_custody(GET_REPORT));
            setIsLoading(false);
        } else if (_get_report.status !== 0) {
            toast.error(_get_report.message);
            dispatch(clear_custody(GET_REPORT));
            setIsLoading(false);
        }
    }, [_get_report, dispatch])

    const handleGenerateReport = (e) => {
        e.preventDefault();
        setIsLoading(true);
        dispatch(get_report({
            'fecha_inicio': range_date.date_start,
            'fecha_fin': range_date.date_end,
            'id_custodiador': other_filter.id_custodian,
            'id_tipo_custodia': other_filter.id_type_custody,
        }, token));

    }

    const [custodian_select_filter, setCustodianSelectFilter] = useState([]);

    const handleChangeCustodianFilter = (e) => {
        setOtherFilter({
            ...other_filter,
            'id_custodian': parseInt(e.value),
        });
        // eslint-disable-next-line
        let va = _get_all_custody.data.datos.filter(element => {
            if (element.custodiadores.match(e.label) != null) {
                return element;
            }
        })
        setDatas(va);
        setCustodianSelectFilter(e);
    }

    const [type_custody_select_filter, setTypeCustodySelectFilter] = useState([]);

    const handleChangeTypeCustodyFilter = (e) => {
        setOtherFilter({
            ...other_filter,
            'id_type_custody': parseInt(e.value),
        });
        let va = _get_all_custody.data.datos.filter(x => parseInt(x.id_tipo_custodia) === parseInt(e.value));
        setDatas(va);
        setTypeCustodySelectFilter(e);
    }

    const dataSelectedInit = {
        id: 0,
        secuencial: "",
        fecha_creacion: "",
        tipo_custodia: "",
        custodiador: "",
        detalle: "",
        comentario: "",
        observacion: "",
        usuario_crea: "",
        fecha_custodia: "",
        fecha_aprobacion_custodia: "",
        estado: "",
    }

    const [DataSelected, setDataSelected] = useState(dataSelectedInit);

    const onItemClickListener = async (item) => {
        const response = await getItemCustody(token, item.id);
        if (response && response.data && response.data.datos) {
            setDateCustody(response.data.datos[0].fecha_custodia);
            setDataSelected(response.data.datos[0]);
        }
        setShowDetail(true);
    }

    useEffect(() => {
        if (_update_custody.status === 200) {
            dispatch(clear_custody(UPDATE_CUSTODY));
            toast.success(_update_custody.message);
            dispatch(getAllCustody(token, 1));
            setForm(initForm);
            setShowOverlay(false);
            setShowSibarRight(false);
            setIsLoading(false);
            setModalDecline(false);
            setModalApproval(false);
            setModalEnd(false);
            setShowDetail(false);
        } else if (_update_custody.status !== 0) {
            toast.error(_update_custody.message);
            dispatch(clear_custody(UPDATE_CUSTODY));
            setForm(initForm);
            setShowOverlay(false);
            setShowSibarRight(false);
            setIsLoading(false);
        }
    }, [_update_custody, dispatch, token, initForm])

    const handleDecline = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (comment === "") {
            toast.error("Debe ingresar un comentario");
            setIsLoading(false);
            return;
        }
        dispatch(updateCustody(token, DataSelected.id, {"tipo": "anulado", "comentario": comment}));
    }

    const handleApproval = (e) => {
        e.preventDefault();
        setIsLoading(true);
        let array = custodian_select.map((item) => {
            return {
                id: item.value,
                nombre: item.label,
            };
        });
        if (array.length === 0) {
            toast.error("Debe seleccionar al menos un custodiador");
            setIsLoading(false);
            return;
        }
        if (date_custody === "") {
            toast.error("Debe seleccionar una fecha");
            setIsLoading(false);
            return;
        }
        dispatch(updateCustody(token, DataSelected.id, {"tipo": "aprobado", "custodiadores": array, "fecha_asignada": date_custody}));
    }

    const handleEnd = (e) => {
        e.preventDefault();
        setIsLoading(true);
        dispatch(updateCustody(token, DataSelected.id, {"tipo": "finalizado", "observacion": observation}));
    }

    // eslint-disable-next-line
    const [filtros, setFiltros] = useState({
        creadas: false,
        aprobadas: false,
        rechazadas: false,
        finalizadas: false,
    });

    const handleFilterState = (e, type) => {
        if (type === "CREADO") {
            filtros.creadas = e.target.checked
        }
        if (type === "APROBADO") {
            filtros.aprobadas = e.target.checked
        }

        if (type === "ANULADO") {
            filtros.rechazadas = e.target.checked
        }

        if (type === "FINALIZADO") {
            filtros.finalizadas = e.target.checked
        }

        let actual = []

        if (filtros.aprobadas && type !== "APROBADO") {
            actual = actual.concat(_get_all_custody.data.datos.filter(x => x.estado === "APROBADO"));
        }
        if (filtros.aprobadas && type !== "FINALIZADO") {
            actual = actual.concat(_get_all_custody.data.datos.filter(x => x.estado === "FINALIZADO"));
        }
        if (filtros.creadas && type !== "CREADO") {
            actual = actual.concat(_get_all_custody.data.datos.filter(x => x.estado === "CREADO"));
        }
        if (filtros.rechazadas && type !== "ANULADO") {
            actual = actual.concat(_get_all_custody.data.datos.filter(x => x.estado === "ANULADO"));
        }

        if (e.target.checked) {
            actual.concat();
            let select = _get_all_custody.data.datos.filter(x => x.estado === type);
            actual = actual.concat(select);
            // const ordenado = actual.sort((a, b) => {
            //     return new Date(b.fecha_visita) - new Date(a.fecha_visita);
            // });
            setDatas(actual)
        } else {
            if (!filtros.aprobadas && !filtros.creadas && !filtros.rechazadas) {
                actual = _get_all_custody.data.datos;
            } else {
                actual.filter(x => x.estado === type).pop()
            }
            // const ordenado = actual.sort((a, b) => {
            //     return new Date(b.fecha_visita) - new Date(a.fecha_visita);
            // });
            setDatas(actual)
        }
    }

    return (
        <div className="app-content content">
            <ToastContainer/>
            {isLoading && <LoadingSpinner/>}
            <div className="content-wrapper">

                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 ">
                        <Breadcrumbs
                            title="Custodias"
                            items={[{label: "Listado custodias", link: "/custodias"}]}
                            onclick
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="content-area-wrapper" style={{margin: 0}}>
                        <div className={`sidebar-left ${showSibarLeft ? 'show' : ''}`}>
                            <div className="sidebar">
                                <div className="sidebar-content email-app-sidebar d-flex">
                                    {/* sidebar close icon */}
                                    <span className="sidebar-close-icon" onClick={
                                        () => {
                                            setShowSibarLeft(false)
                                            setShowOverlay(false)
                                        }
                                    }>
                                        <i className="bx bx-x"/>
                                    </span>
                                    {/* sidebar close icon */}
                                    <div className="email-app-menu">
                                        <div className="form-group form-group-compose">
                                            {/* compose button  */}
                                            {
                                                permisos.filter(element => element.codigo === "add_custody").length > 0 &&
                                                <Button
                                                    text="Solicitar custodia"
                                                    onChange={() => {
                                                        setShowSibarRight(!showSibarRight);
                                                        setShowSibarLeft(false);
                                                        setShowDetail(false);
                                                        setForm(initForm)
                                                        setEstablishmentSelect([]);
                                                        setShowOverlay(!showSibarRight);
                                                        setTypeCustodySelect([]);
                                                    }}
                                                    theme="success"
                                                    classes=" btn-block my-2 compose-btn"
                                                />
                                            }
                                        </div>
                                        <div className="sidebar-menu-list">
                                            {/* sidebar menu  */}
                                            <div className="list-group list-group-messages">
                                                <SelectInput
                                                    id="filtro-custody"
                                                    name="filtro-custody"
                                                    options={filter_options}
                                                    onChange={filterToday}
                                                />
                                                <ul className="list-unstyled mb-0">
                                                    {
                                                        range_date.visible && <>
                                                            <li className=" mr-2 mb-1">
                                                                <Input
                                                                    type="date"
                                                                    label="Fecha Inicio"
                                                                    onChange={handleFilterRangeDate}
                                                                    name='date_start'

                                                                />
                                                                <Input
                                                                    type="date"
                                                                    label="Fecha Fin"
                                                                    onChange={handleFilterRangeDate}
                                                                    name='date_end'

                                                                />
                                                            </li>
                                                        </>
                                                    }
                                                    {
                                                        other_filter.visible_custodian && <>
                                                            <li className=" mr-2 mb-1">
                                                                <label>Custodiador</label>
                                                                <Select
                                                                    options={custodian}
                                                                    isMulti={false}
                                                                    onChange={handleChangeCustodianFilter}
                                                                    value={custodian_select_filter}
                                                                />
                                                            </li>
                                                        </>
                                                    }
                                                    {
                                                        other_filter.visible_type_custody && <>
                                                            <li className=" mr-2 mb-1">
                                                                <label>Tipo de custodia</label>
                                                                <Select
                                                                    options={typeCustody}
                                                                    isMulti={false}
                                                                    onChange={handleChangeTypeCustodyFilter}
                                                                    value={type_custody_select_filter}
                                                                />
                                                            </li>
                                                        </>
                                                    }
                                                    <li className=" mr-2 mb-1">
                                                        <CheckBox
                                                            label="CREADAS"
                                                            name="check-creadas"
                                                            id="check-creadas"
                                                            onChange={(e) => {
                                                                handleFilterState(e, "CREADO");
                                                            }}
                                                            state={filtros.creadas}
                                                        />
                                                    </li>
                                                    <li className=" mr-2 mb-1">
                                                        <CheckBox
                                                            label="APROBADAS"
                                                            name="check-aprobadas"
                                                            id="check-aprobadas"
                                                            onChange={(e) => {
                                                                handleFilterState(e, "APROBADO");
                                                            }}
                                                            state={filtros.aprobadas}
                                                        />
                                                    </li>
                                                    <li className=" mr-2 mb-1">
                                                        <CheckBox
                                                            label="FINALIZADAS"
                                                            name="check-finalizadas"
                                                            id="check-finalizadas"
                                                            onChange={(e) => {
                                                                handleFilterState(e, "FINALIZADO");
                                                            }}
                                                            state={filtros.finalizadas}
                                                        />
                                                    </li>
                                                    <li className=" mr-2 mb-1">
                                                        <CheckBox
                                                            label="RECHAZADAS"
                                                            name="check-rechazadas"
                                                            id="check-rechazadas"
                                                            onChange={(e) => {
                                                                handleFilterState(e, "ANULADO");
                                                            }}
                                                            state={filtros.rechazadas}
                                                        />
                                                    </li>
                                                </ul>
                                            </div>
                                            {/* sidebar label end */}
                                        </div>
                                    </div>
                                </div>
                                {/* User new mail right area */}
                                {
                                    permisos.filter(element => element.codigo === "add_custody").length > 0 ?
                                        <div className={`compose-new-mail-sidebar ${showSibarRight ? 'show' : ''}`}
                                             style={{
                                                 overflowY: 'scroll',
                                             }}
                                        >
                                            <div className="card shadow-none quill-wrapper p-0">
                                                <div className="card-header">
                                                    <h3 className="card-title" id="custody">
                                                        Solicitar custodia
                                                    </h3>
                                                    <button type="button" className="close close-icon"
                                                            onClick={() => {
                                                                setShowSibarRight(false);
                                                                setShowSibarLeft(false);
                                                                setShowOverlay(false);
                                                            }}
                                                    >
                                                        <i className="bx bx-x"/>
                                                    </button>
                                                </div>
                                                {/* form start */}
                                                <form onSubmit={handleSubmit} id="compose-form">
                                                    <div className="card-content">
                                                        <div className="card-body pt-0">
                                                            <label className="form-label">Establecimientos</label>
                                                            <Select
                                                                options={establishment}
                                                                isMulti={true}
                                                                onChange={handleChangeEstablishment}
                                                                value={establishment_select}
                                                            />
                                                            <br/>
                                                            <label className="form-label">Tipo de custodia</label>
                                                            <Select
                                                                options={typeCustody}
                                                                isMulti={false}
                                                                onChange={handleChangeTypeCustody}
                                                                value={type_custody_select}
                                                            />
                                                            <br/>
                                                            <Input
                                                                type="date"
                                                                name="fecha_custodia"
                                                                id="fecha_custodia"
                                                                label="Fecha"
                                                                onChange={handleChange}
                                                                placeholder=""
                                                                value={form.fecha_custodia}
                                                            />
                                                            <TextArea
                                                                id="detalle"
                                                                name="detalle"
                                                                label="Detalle"
                                                                placeholder=""
                                                                onChange={handleChange}
                                                                rows={4}
                                                                value={form.detalle}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="card-footer d-flex justify-content-end pt-0">
                                                        <Button
                                                            text="Cancelar"
                                                            theme="light-secondary"
                                                            type="reset"
                                                            classes="cancel-btn mr-1"
                                                            onChange={() => {
                                                                setShowSibarRight(false);
                                                                setShowOverlay(!showOverlay);
                                                            }}
                                                        />
                                                        <Button
                                                            text="Guardar"
                                                            onChange={() => {
                                                                //TODO: AGREGAR FUNCIONALIDAD DE CREAR CUSTODYA
                                                            }}
                                                            theme="success"
                                                            type="submit"
                                                            disabled={isLoading}
                                                        />
                                                    </div>
                                                </form>
                                                {/* form start end*/}
                                            </div>
                                        </div> : null}
                                {/*/ User Chat profile right area */}
                            </div>
                        </div>
                        <div className="content-right">
                            <div className="content-overlay"/>
                            <div className="content-wrapper">
                                <div className="content-header row"/>
                                <div className="content-body">
                                    {/* email app overlay */}
                                    <div className={`app-content-overlay ${showOverlay ? 'show' : ''}`}
                                         onClick={
                                             () => {
                                                 setShowSibarRight(!showSibarRight);
                                                 setShowSibarLeft(false);
                                                 setShowDetail(false);
                                                 setShowOverlay(!showOverlay);
                                             }
                                         }
                                    />
                                    <div className="email-app-area">
                                        {/* Email list Area */}
                                        <div className="email-app-list-wrapper">
                                            <div className="email-app-list">
                                                <div className="email-action">
                                                    <div
                                                        className="action-right d-flex flex-grow-1 align-items-center justify-content-around">
                                                        {/* search bar  */}
                                                        <div className="email-fixed-search flex-grow-1">
                                                            <div className="sidebar-toggle d-block d-lg-none" onClick={
                                                                () => {
                                                                    setShowSibarLeft(!showSibarLeft);
                                                                    setShowOverlay(!showOverlay);
                                                                }
                                                            }>
                                                                <i className="bx bx-menu"/>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-10">
                                                                    <Search placeholder={"Buscar por establecimiento o número de solicitud"}
                                                                            onChange={handleSearch}
                                                                    />
                                                                </div>
                                                                {permisos.filter(element => element.codigo === "generate_report_custody").length > 0 &&
                                                                    <div className="col-2">
                                                                        <Button
                                                                            text={<h3><i
                                                                                className="text-white bx bx-export"/></h3>}
                                                                            theme="success"
                                                                            type="button"
                                                                            classes="btn-lg round"
                                                                            onClick={handleGenerateReport}
                                                                        />
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                        {/* pagination and page count */}
                                                    </div>
                                                </div>
                                                {/* / action right */}

                                                <div className="row" style={{marginTop: 10, marginBottom: 5}}>
                                                    <div className="col-4">
                                                        <label className="ml-1">Página {page}</label>
                                                    </div>
                                                    <div className="col-8 text-right">
                                                        {(page > 1 && page <= n_page) &&
                                                            <button className="btn btn-primary mr-1" type="button"
                                                                    onClick={() => {
                                                                        less_data();
                                                                    }}><i className="bx bx-arrow-back"></i></button>
                                                        }
                                                        {(page >= 1 && page < n_page) &&
                                                            <button className="btn btn-success" type="button"
                                                                    onClick={() => {
                                                                        more_data();
                                                                    }}><i className="bx bx-right-arrow-alt"></i></button>
                                                        }
                                                    </div>
                                                </div>

                                                {/* email user list start */}
                                                <div className="email-user-list list-group">
                                                    <ul className="users-list-wrapper media-list" style={{
                                                        overflowY: 'scroll',
                                                    }}>
                                                        <InfiniteScroll
                                                            pageStart={0}
                                                            loadMore={() => loadFunc()}
                                                            hasMore={HasMore}
                                                            useWindow={false}
                                                            loader={
                                                                <div className="col-12 d-flex justify-content-center">
                                                                    <div
                                                                        className="spinner-border text-success"
                                                                        role="status"
                                                                    >
                                                                        <span className="sr-only">Loading...</span>
                                                                    </div>
                                                                    {" "}
                                                                </div>
                                                            }
                                                        >
                                                            {datas.map((item, index) => (
                                                                <ItemList1
                                                                    item={item}
                                                                    title={item.tipo_custodia}
                                                                    subtitle={item.secuencial}
                                                                    rightDescription={item.estado}
                                                                    bulletType={get_status(item.estado)}
                                                                    children={
                                                                        <div className="user-details div_fecha">
                                                                            <div className="mail-items">
                                                                                <small>{item.establecimientos}</small>
                                                                            </div>
                                                                            <div className="mail-items">
                                                                                <small>Fecha: {item.fecha_custodia}</small>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    onClick={onItemClickListener}
                                                                />
                                                            ))}
                                                        </InfiniteScroll>
                                                    </ul>
                                                    {/* email user list end */}

                                                    {/* no result when nothing to show on list */}
                                                    <div className="no-results">
                                                        <i className="bx bx-error-circle font-large-2"/>
                                                        <h5>No Items Found</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/*/ Email list Area */}

                                        {/* Detailed Email View */}
                                        <div className={`email-app-details ${showDetail ? 'show' : ''} `}>
                                            {/* email detail view header */}
                                            <div className="email-detail-header">
                                                <div className="email-header-left d-flex align-items-center mb-1">
                                                    <span className="go-back mr-50" onClick={
                                                        () => {
                                                            setShowDetail(false);
                                                        }
                                                    }>
                                                        <span className="fonticon-wrap d-inline">
                                                        <i className="bx bx-arrow-back"/>
                                                        </span>
                                                    </span>
                                                    <h5 className="email-detail-title font-weight-normal mb-0">
                                                        {DataSelected.secuencial}
                                                    </h5>
                                                </div>
                                                <div className="email-header-right mb-1 ml-2 pl-1">
                                                    <span
                                                        className={`badge badge-light-${get_status(DataSelected.estado)} badge-pill ml-1`}>
                                                        {DataSelected.estado}
                                                    </span>
                                                </div>
                                            </div>
                                            {/* email detail view header end*/}
                                            <div className="email-scroll-area" style={{overflowY: 'scroll',}}>
                                                {/* email details  */}
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="collapsible email-detail-head">
                                                            <Card
                                                                title={DataSelected.establecimientos}
                                                                subtitle={DataSelected.fecha}
                                                            >
                                                                <div className="row">
                                                                    {(DataSelected.tipo_custodia) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Tipo: </h6>{DataSelected.tipo_custodia}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.detalle) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Detalle: </h6>{DataSelected.detalle}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.fecha_custodia) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Fehca de creación custodia: </h6>{DataSelected.fecha_custodia}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.fecha_asignacion_custodia) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Fecha de asignación de custodia: </h6>{DataSelected.fecha_asignacion_custodia}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.fecha_asignacion_custodia) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Fecha de asignación de custodia: </h6>{DataSelected.fecha_asignacion_custodia}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.custodiadores) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Custodiadores: </h6>{DataSelected.custodiadores}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.comentario) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Comentario: </h6>{DataSelected.comentario}
                                                                        </div>
                                                                    }
                                                                    {(DataSelected.observacion) &&
                                                                        <div className="col-12 mb-1">
                                                                            <h6>Observación: </h6>{DataSelected.observacion}
                                                                        </div>
                                                                    }
                                                                    <div className="col-12 div-flex mt-2 mb-5">
                                                                        {permisos.filter(item => item.codigo === "can_approve_custody").length > 0 && DataSelected.estado === "CREADO" ? (
                                                                                <>
                                                                                    <Button
                                                                                        text="Rechazar"
                                                                                        onChange={
                                                                                            () => {
                                                                                                setComment("");
                                                                                                setModalDecline(true);
                                                                                            }
                                                                                        }
                                                                                        theme="danger"
                                                                                        classes="button_div1"
                                                                                        type="button"
                                                                                        disabled={isLoading}
                                                                                    />
                                                                                    <Button
                                                                                        text="Aprobar"
                                                                                        onClick={
                                                                                            () => {
                                                                                                setCustodianSelect([]);
                                                                                                setModalApproval(true);
                                                                                            }
                                                                                        }
                                                                                        theme="success"
                                                                                        classes="button_div1"
                                                                                        type="submit"
                                                                                        disabled={isLoading}
                                                                                    />
                                                                                </>
                                                                            ) : null
                                                                        }
                                                                        {permisos.filter(item => item.codigo === "can_end_custody").length > 0 && DataSelected.estado === "APROBADO" && (
                                                                            <Button
                                                                                text="Finaliar"
                                                                                onClick={
                                                                                    () => {
                                                                                        setObservation("");
                                                                                        setModalEnd(true);
                                                                                    }
                                                                                }
                                                                                theme="success"
                                                                                classes="button_div1"
                                                                                type="submit"
                                                                                disabled={isLoading}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </Card>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* email details  end*/}
                                                <div className="row px-2 mb-4">
                                                    {/* quill editor for reply message */}
                                                    <div className="col-12 px-0"/>
                                                </div>
                                            </div>
                                        </div>
                                        {/*/ Detailed Email View */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modalDecline}>
                <form onSubmit={handleDecline}>
                    <div className="card-body">
                        <h5 className="mb-2">Rechazar Custodio</h5>
                        <div className="form-group">
                            <TextArea
                                id="commentario"
                                name="comment"
                                label="Comentario"
                                placeholder=""
                                onChange={(e) => setComment(e.target.value)}
                                rows={4}
                                value={comment}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button className={`btn btn-success button_div`} disabled={isLoading}>Continuar</button>
                        <button type="button" onClick={() => {
                            setModalDecline(false);
                        }} className={`btn btn-outline-danger button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal" show={modalApproval}>
                <form onSubmit={handleApproval}>
                    <div className="card-body">
                        <h5 className="mb-2">Aprobar Custodio</h5>
                        <div className="form-group">
                            <label className="form-label">Custodiador(es)</label>
                            <Select
                                options={custodian}
                                isMulti={true}
                                onChange={handleChangeCustodian}
                                value={custodian_select}
                            />
                            <br/>
                            <Input
                                 type="datetime-local"
                                name="date_custody"
                                id="date_custody"
                                label="Fecha"
                                onChange={(e) => setDateCustody(e.target.value)}
                                placeholder=""
                                value={date_custody}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button className={`btn btn-success button_div`} disabled={isLoading}>Continuar</button>
                        <button type="button" onClick={() => {
                            setModalApproval(false);
                        }} className={`btn btn-outline-danger button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal className="modal-main div-modal1" show={modalEnd}>
                <form onSubmit={handleEnd}>
                    {isLoading && <LoadingSpinner />}
                    <div className="card-body">
                        <h5 className="titulo_modal mb-2">Finalizar</h5>
                        <div className="form-group">
                            <TextArea
                                label="Observación (opcional)"
                                name="observation"
                                onChange={(e) => setObservation(e.target.value)}
                                value={observation}
                                rows={5}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-success button_div`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModalEnd(false);
                        }} className={`btn btn-outline-dark button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
        </div>
    );
};

export default CustodesAdmin;
